import moment from "moment";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { Note } from "@/Common/Models/Note";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface INotesToolTipControlPopup {
    ControlId: string;
    notes: Note[];
    Value: string;

    ReferenceId: string;

    Target?: number;
    SubReferenceId?: string;

    EventToDispatchOnSave: number;
    EventToDispatchOnTextChanged: number;
    EventToDispatchOnDropdownClosed: number;
    leftPosition: number;
    topPosition: number;
    OnResizeoperation?: number;
    isManualLabEntry?: boolean;
}

class NotesToolTipControl extends BaseReactComponent<INotesToolTipControlPopup> {
    private timeoutOnSubmitNotes: number;

    public constructor(props: INotesToolTipControlPopup) {
        super(props);

        this.timeoutOnSubmitNotes = -1;
    }

    public render(): JSX.Element {
        var self = this;

        const style: React.CSSProperties = {
            position: "absolute",
            left: self.props.leftPosition + "px",
            top: self.props.topPosition + "px"
        };

        var content = null;

        if (this.props.notes == null || this.props.notes.length === 0) { content = this.renderEmpty(); }

        else { content = this.renderWithNotes(); }

        var IsDisabled = this.props.Value == null || this.props.Value.trim().length == 0;

        return (
            <div id={this.props.ControlId} onClick={this.cancelClickPropagation} data-dropdown-content className="notes-modal" aria-hidden="false" style={style} aria-autoclose="false">
                {content}
                <div className="notes-content-footer text-right">

                    <button className="btn btn-default push-right-5" onClick={() => self.onClose()}>{cacheStore.GetString("CloseLabel")}</button>
                    <button className="btn btn-primary" disabled={IsDisabled} onClick={this.SubmitNote.bind(this)}>{cacheStore.GetString("NoteSubmitLabel")}</button>
                </div>
            </div>
        );
    }

    private renderWithNotes(): JSX.Element {
        let notesRenderList: JSX.Element[] = [];
        for (let i = this.props.notes.length - 1; i >= 0; i--) {
            notesRenderList.push(this.renderNoteLine(this.props.notes[i], i));
        }

        return (
            <div className="notes-dropdown-content">
                <h4>{cacheStore.GetString("NotesDLabel")}</h4>
                <div className="scroll-limit">
                    <div style={{ width: "95%" }}> {/* Prevent Horizontal Scroll Bar */}
                        {notesRenderList}
                    </div>
                </div>
                <textarea className="form-control" value={this.props.Value} id="memo_doctb" onChange={this.onTexboxChange.bind(this)} rows={4} style={{ resize: "none" }} />
            </div>
        );
    }

    private renderNoteLine(note: Note, idx: number): JSX.Element {
        let person = cacheStore.GetCliniciansPersonsByContactId(note.ContactId);
        return (
            <div key={note.NoteId + "_" + idx} className="notes-collection-item">
                <div className="memo-header"><strong>{person.NameWithPrefix}</strong> <span>{moment(note.NoteDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("AtLabel") + " " + moment(note.NoteDate).format("HH:mm:ss")}</span></div>
                <div className="note-container">
                    {JSXHelper.BreakStringIntoParagraphs(note.NoteContent)}
                </div>
            </div>
        );
    }

    private cancelClickPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private renderEmpty(): JSX.Element {
        return (
            <div className="notes-dropdown-content">
                <h4>{cacheStore.GetString("NotesDLabel")}</h4>
                <textarea className="form-control" value={this.props.Value} id="memo_doctb" onChange={this.onTexboxChange.bind(this)} rows={4} />
            </div>
        );
    }

    public SubmitNote(): void {
        if (this.timeoutOnSubmitNotes !== -1) {
            clearTimeout(this.timeoutOnSubmitNotes);
            this.timeoutOnSubmitNotes = -1;
        }

        this.timeoutOnSubmitNotes = window.setTimeout(() => {
            var operation = new LocalEvent(this.props.EventToDispatchOnSave);
            operation.AddItem("ReferenceId", this.props.ReferenceId);
            operation.AddItem("Target", this.props.Target);
            operation.AddItem("SubReferenceId", this.props.SubReferenceId);
            operation.AddItem("value", this.props.Value);
            operation.AddItem("isManualLabEntry", this.props.isManualLabEntry);
            LocalEventDispatcher.dispatch(operation);
        }, 300);
    }

    private onTexboxChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {
        var operation = new LocalEvent(this.props.EventToDispatchOnTextChanged);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    public shouldComponentUpdate(nextProp: INotesToolTipControlPopup): boolean {
        return (
            this.props.ReferenceId !== nextProp.ReferenceId
            || this.props.SubReferenceId !== nextProp.SubReferenceId
            || this.props.Target !== nextProp.Target
            || this.props.Value !== nextProp.Value
            || this.props.leftPosition !== nextProp.leftPosition
            || this.props.topPosition !== nextProp.topPosition
        );
    }

    public componentDidMount(): void {
        super.setOverlay("ResultsNotesPopup", { transparent: true });

        var self = this;
        $("#" + this.props.ControlId).on("opened.fndtn.dropdown", function() { $(this).find("textarea").css({ height: "40px" }); });
        $("#" + this.props.ControlId).on("closed.fndtn.dropdown", () => self.onClose());

        window.addEventListener("resize", this.resizeHandler);
        var elem = document.getElementById("memo_doctb");
        autosize(elem);
        elem.focus();
    }

    public onClose(): void {
        var self = this;
        var operation = new LocalEvent(self.props.EventToDispatchOnDropdownClosed);
        LocalEventDispatcher.dispatch(operation);
    }

    private resizeHandler(): void {
        if (this.props && this.props.OnResizeoperation != null) {
            var operation = new LocalEvent(this.props.OnResizeoperation);
            LocalEventDispatcher.dispatch(operation);
        }
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();
        window.removeEventListener("resize", this.resizeHandler);
        var elem = document.getElementById("memo_doctb");
        var event = document.createEvent("Event");
        event.initEvent("autosize:destroy", true, false);
        elem.dispatchEvent(event);
    }
}

export { NotesToolTipControl };
